(ns common.schema.entities.integration.ai-service
  "A per-tenant AI provider configuration (e.g. a Claude or OpenAI endpoint).
   Multiple may be configured; work is routed to one via ai-task-config or the
   tenant default. The api-key is a secret: writable by admins, never
   serialized to any client (read :role/system, mirroring the reporting-db
   passwords). The admin UI only ever sees :has-api-key?; read_serialization
   also deny-lists the attribute as defense in depth."
  (:require [common.schema.entities.integration.ai-options :as ai-options]
            [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/text-simple-field :ai-service/label "Label"
                          {:authorization su/access-admin-admin})
    (su/keyword-field :ai-service/provider "Provider" ai-options/provider-options
                      {:authorization su/access-admin-admin})
    (su/url-field :ai-service/base-url "Base URL"
                  {:authorization su/access-admin-admin})
    (su/text-simple-field :ai-service/model "Model"
                          {:authorization su/access-admin-admin})
    (su/text-simple-field :ai-service/api-key "API key"
                          {:authorization su/access-admin-system})
    (su/boolean-field :ai-service/enabled? "Enabled"
                      {:authorization su/access-admin-admin})
    ;; Written by the verification endpoint, never by an admin editing the
    ;; form, hence :role/system write access. They record the last check so the
    ;; admin panel can show health on load rather than only after a manual
    ;; test, and so a configuration last confirmed working months ago is
    ;; visibly stale.
    (su/datetime-field :ai-service/last-verified-on "Last verified"
                       {:authorization su/access-system-admin})
    (su/keyword-field :ai-service/last-verification-outcome
                      "Last verification outcome"
                      ai-options/verification-outcome-options
                      {:authorization su/access-system-admin}))))
